import PropTypes from 'prop-types';
import { FaCommentDots } from 'react-icons/fa';

export default function NameWithCommentIcon({ row }) {
  const { original } = row;
  const hasComment = original.OBSERVACIONS && original.OBSERVACIONS.trim().length > 0;
    console.log("original 0:", original);

  return (
//   <div className="flex items-center gap-2">
//     {original.COGNOMS_NOM}
//     <span className="text-xs text-gray-400">{hasComment ? '🟢' : '🔴'}</span>
//     {hasComment && <FaCommentDots className="text-indigo-500" />}
//   </div>
<div
  className="flex items-center gap-2"
  title={hasComment ? original.OBSERVACIONS : ''}
>
  {original.COGNOMS_NOM || original.NOM}
  {hasComment && <FaCommentDots className="text-indigo-500" size={17} />}
</div>


);
  
}

NameWithCommentIcon.propTypes = {
  row: PropTypes.object.isRequired,
};
